import React from "react"

import WPCta from "../_base/WPCta"

import * as callToActionStyles from "../../styles/world_championships/CallToAction.module.css"

const Action = props => {
  const { content } = props

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <WPCta
            holder={content}
            selector={`cta-btn`}
            translate={false}
            className={`${callToActionStyles.ctaBtn}`}
          />
        </div>
      </div>
    </div>
  )
}

export default Action
